import us from "./us.json";
import am from "./am.json";
import ru from "./ru.json";

export const translations = {
  us: us,
  am: am,
  ru: ru,
};
